import React from 'react';
// import { Link } from 'react-router-dom';
// import BrandedMissionName from '../common/BrandedMissionName';
// import { HeartHandshake, Mail, MapPin, Phone } from 'lucide-react';
// import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-3 md:py-4 mt-auto w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* <div className="grid gap-8 text-center md:grid-cols-4 md:text-left">
          <div>
            <div className="flex justify-center mb-3">
              <HeartHandshake size={30} className="text-white" />
            </div>
            <h3 className="mb-3 text-lg font-semibold">
              <BrandedMissionName variant="title" />
            </h3>
            <p className="text-sm text-white/90 leading-6">
              Building hope through education, awareness, and community-led initiatives that empower
              women and families.
            </p>
          </div>

          <div className="md:pl-24">
            <h4 className="text-base font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white/90">
              <li>
                <Link to="/" className="hover:text-accent transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent transition-colors">About</Link>
              </li>
              <li>
                <Link to="/awards" className="hover:text-accent transition-colors">Awards</Link>
              </li>
              <li>
                <Link to="/support-us" className="hover:text-accent transition-colors">Support Us</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-accent transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-3">Images & Videos</h4>
            <ul className="space-y-2 text-sm text-white/90">
              <li>
                <Link to="/videos" className="hover:text-accent transition-colors">Videos</Link>
              </li>
              <li>
                <Link to="/dhm-works" className="hover:text-accent transition-colors">DHM Works</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-3">Contact</h4>
            <ul className="space-y-2 text-sm text-white/90">
              <li className="flex items-center justify-center gap-2 md:justify-start">
                <Mail size={14} className="shrink-0" />
                <span>courage@drishtikonhimmatwaalimission.org</span>
              </li>
              <li className="flex items-center justify-center gap-2 md:justify-start">
                <Phone size={14} className="shrink-0" />
                <span>+91 98765 43210</span>
              </li>
              <li className="flex items-center justify-center gap-2 md:justify-start">
                <MapPin size={14} className="shrink-0" />
                <span>Delhi</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center justify-center gap-4 md:justify-start">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="h-8 w-8 rounded-full border border-white/50 flex items-center justify-center hover:text-accent hover:border-accent transition-colors"
              >
                <FaFacebookF size={14} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="h-8 w-8 rounded-full border border-white/50 flex items-center justify-center hover:text-accent hover:border-accent transition-colors"
              >
                <FaInstagram size={14} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="h-8 w-8 rounded-full border border-white/50 flex items-center justify-center hover:text-accent hover:border-accent transition-colors"
              >
                <FaYoutube size={14} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="h-8 w-8 rounded-full border border-white/50 flex items-center justify-center hover:text-accent hover:border-accent transition-colors"
              >
                <FaTwitter size={14} />
              </a>
            </div>
          </div>
        </div> */}

        {/* border-t border-white/20 */}
        <p className="text-center text-sm text-gray-600 sm:text-left">
          © {new Date().getFullYear()},{' '}
          <a
            href="https://100billiontech.com/ownership"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-accent transition-colors"
          >
            Copy-rights reserved
          </a>
          . Designed by{' '}
          <a
            href="https://100billiontech.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-accent transition-colors"
          >
            100billion Tech
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
